import type { IconSvgObject } from './types';

const GoogleLensIcon: IconSvgObject = [
  ["path", { d: "M21 14V8C21 6.34315 19.6569 5 18 5H6C4.34315 5 3 6.34315 3 8V11M13 21H6C4.34315 21 3 19.6569 3 18V15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10 3H14L15 4.5H9L10 3Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["circle", { cx: "12", cy: "13", r: "3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["circle", { cx: "19", cy: "19", r: "2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default GoogleLensIcon;
